import React from "react";
import SurveyForm from "../components/SurveyForm";
import EmailTemplateEditor from "../components/EmailTemplate";
import type { SurveyInfo, SurveyQuestion } from "../types/defaultTypes";
import type { ValidationError } from "../utils/validateSurvey";

interface SelectTabProps {
  tab: "manage" | "email" | "users";
  isFetching: boolean;
  sensors: any[];
  surveyInfo: SurveyInfo;
  setSurveyInfo: React.Dispatch<React.SetStateAction<SurveyInfo>>;
  questions: SurveyQuestion[];
  setQuestions: React.Dispatch<React.SetStateAction<SurveyQuestion[]>>;
  formErrors: ValidationError | null;
  email: {
    header: string;
    subheader: string;
    text: string;
    subject: string;
  };
  setEmail: React.Dispatch<
    React.SetStateAction<{
      header: string;
      subheader: string;
      text: string;
      subject: string;
    }>
  >;
}

const SelectTab: React.FC<SelectTabProps> = ({
  tab,
  isFetching,
  sensors,
  surveyInfo,
  setSurveyInfo,
  questions,
  setQuestions,
  formErrors,
  email,
  setEmail,
}) => {
  if (tab === "manage")
    return isFetching ? (
      <div className="w-full h-full flex items-center justify-center">
        <div className="animate-spin rounded-full self-center h-12 w-12 border-b-2 border-orange-500"></div>
      </div>
    ) : (
      <SurveyForm
        sensors={sensors}
        surveyInfo={surveyInfo}
        setSurveyInfo={setSurveyInfo}
        questions={questions}
        setQuestions={setQuestions}
        formErrors={formErrors}
      />
    );

  if (tab === "email")
    return isFetching ? (
      <div className="w-full h-full flex items-center justify-center">
        <div className="animate-spin rounded-full self-center h-12 w-12 border-b-2 border-orange-500"></div>
      </div>
    ) : (
      <EmailTemplateEditor email={email} setEmail={setEmail} />
    );

  return null;
};

export default React.memo(SelectTab);
